import classNames from "classnames/bind";

import styles from "./PDPPromoArea.module.scss";

const cx = classNames.bind(styles);

export type PDPPromoAreaProps = {
    fullWidth?: boolean;
    children?: React.ReactNode;
    id?: string;
    bgColor?: string;
    textColor?: string;
};

export const PDPPromoArea = ({
    fullWidth = false,
    children,
    id,
    bgColor,
    textColor,
}: PDPPromoAreaProps) => {
    return (
        <div
            id={id}
            className={cx("promo", { fullWidth })}
            style={{ backgroundColor: bgColor, color: textColor }}
        >
            {children}
        </div>
    );
};
